import {Image} from 'react-bootstrap';
import sportcastLogo from '../../../assets/SportcastLogoDataPrivacy.png';
import './LegalHeader.scss';

const TermsOfUseHeader = () => {
    return (
        <div className="terms-of-use-headline">
            <b>Nutzungsbedingungen für das RePort-Portal</b>
            <p>
                <Image src={sportcastLogo} height={'75px'} width={'75px'} alt="Sportcast"/>
            </p>
        </div>
    );
};

export default TermsOfUseHeader;